import React from "react";
import {
  Button, Card, CardHeader, CardBody, ListGroupItem,
  Container, Row, Col, CardImg,ListGroup
} from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import creditCardsImg from "@/assets/img/theme/creditcards.svg";
import type { PagesBySiteResponse } from "../../../../../shared/apiTypes";
/** The fields the dashboard lists read from each slice row. */
type DashboardCategory = { _id?: string; name?: string };
type DashboardProduct = {
  _id?: string;
  title?: string;
  country_code?: string;
  productImg: string;
};

export type DashboardViewProps = {
  siteCategories: DashboardCategory[];
  products: DashboardProduct[];
  pages: PagesBySiteResponse;
  CatlimitTo: number;
  ProdlimitTo: number;
  PagelimitTo: number;
  onLoadMoreCat: () => void;
  onLoadMoreProd: () => void;
  onLoadMorePage: () => void;
};

const DashboardView = ({
  siteCategories, products, pages,
  CatlimitTo, ProdlimitTo, PagelimitTo,
  onLoadMoreCat, onLoadMoreProd, onLoadMorePage,
}: DashboardViewProps) => (
  <>
    <SimpleHeader name="Default" parentName="Dashboards" />
    <Container className="mt--6" fluid>
      <Row>
        <Col lg="12">
          <Card>
            <CardImg
              alt="..."
              src={creditCardsImg}
              className="credit-card-img"
              style={{ maxHeight: "800px", display: "block", width: "auto" }}
              top
            />
          </Card>
        </Col>
      </Row>

      <Row>
        {/* Product Types */}
        <Col xl="4">
          <Card>
            <CardHeader>
              <Row><Col><h5 className="h2 mb-0 text-center">Product Types</h5></Col></Row>
            </CardHeader>
            <CardBody className="p-0">
              <ListGroup data-toggle="checklist" flush>
                {siteCategories.slice(0, CatlimitTo).map((category) => (
                  <ListGroupItem
                    className="checklist-entry flex-column align-items-start py-4 px-4"
                    key={category._id}
                  >
                    <div className="d-flex align-items-center">
                      <div className="mx-3">
                        <h4 className="mb-0">
                          <a href="#!" onClick={(e)=>e.preventDefault()}>{category.name}</a>
                        </h4>
                      </div>
                    </div>
                  </ListGroupItem>
                ))}
                <br />
                <Container className="text-center">
                  <Button className="btn-icon" color="primary" size="sm" type="button" onClick={onLoadMoreCat}>
                    <span className="btn-inner--text">View all</span>
                  </Button>
                </Container>
                <br />
              </ListGroup>
            </CardBody>
          </Card>
        </Col>

        {/* Site Products */}
        <Col xl="4">
          <Card>
            <CardHeader>
              <Row><Col><h5 className="h2 mb-0 text-center">Site Products</h5></Col></Row>
            </CardHeader>
            <CardBody className="p-0">
              <ListGroup data-toggle="checklist" flush>
                {products.slice(0, ProdlimitTo).map((product) => (
                  <ListGroupItem
                    className="checklist-entry flex-column align-items-start py-4 px-4"
                    key={product._id}
                  >
                    <div className="d-flex align-items-center">
                      <a href="#!" onClick={(e)=>e.preventDefault()}>
                        <img
                          alt="..."
                          className="avatar"
                          src={
                            "https://res.cloudinary.com/netcapitalcms/image/upload/" +
                            product.country_code + "/product/" + product.productImg.split("/").pop()
                          }
                        />
                      </a>
                      <div className="mx-3">
                        <h4 className="mb-0">
                          <a href="#!" onClick={(e)=>e.preventDefault()}>{product.title}</a>
                        </h4>
                      </div>
                    </div>
                  </ListGroupItem>
                ))}
                <br />
                <Container className="text-center">
                  <Button className="btn-icon" color="primary" size="sm" type="button" onClick={onLoadMoreProd}>
                    <span className="btn-inner--text">View all</span>
                  </Button>
                </Container>
                <br />
              </ListGroup>
            </CardBody>
          </Card>
        </Col>

        {/* Site Pages */}
        <Col xl="4">
          <Card>
            <CardHeader>
              <Row><Col><h5 className="h2 mb-0 text-center">Site Pages</h5></Col></Row>
            </CardHeader>
            <CardBody className="p-0">
              <ListGroup data-toggle="checklist" flush>
                {pages.slice(0, PagelimitTo).map((page) => (
                  !page.type && (
                    <ListGroupItem
                      className="checklist-entry flex-column align-items-start py-4 px-4"
                      key={String(page._id)}
                    >
                      <div className="mx-3">
                        <a className="text-dark font-weight-600 text-sm" href="#!" onClick={(e)=>e.preventDefault()}>
                          {page.global_title}
                        </a>
                      </div>
                    </ListGroupItem>
                  )
                ))}
                <br />
                <Container className="text-center">
                  <Button className="btn-icon" color="primary" size="sm" type="button" onClick={onLoadMorePage}>
                    <span className="btn-inner--text">View all</span>
                  </Button>
                </Container>
                <br />
              </ListGroup>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </>
);

export default DashboardView;
